import { render, staticRenderFns } from "./insertCharacterUser.vue?vue&type=template&id=4a3b8e15&"
import script from "./insertCharacterUser.vue?vue&type=script&lang=js&"
export * from "./insertCharacterUser.vue?vue&type=script&lang=js&"
import style0 from "./insertCharacterUser.vue?vue&type=style&index=0&id=4a3b8e15&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports